<template>
    <li class="historyLesson" :class="{ noRecord: !lesson.record }" v-if="lesson.record">
        <router-link
            :to="{ name: 'proPlayerLesson', params: { id: lesson.player_id, lesson: lesson.id } }"
        >
            <span>
                <b
                    ><span v-if="!lesson.title">Untitled record</span
                    ><span class="title" v-else>{{ lesson.title }}</span></b
                >
                {{ $date(lesson.date).format("DD MMM YYYY") }}

                <lesson-star :lesson="lesson" />

                <button
                    class="button"
                    @click.prevent="AddLesson"
                    :class="{ active: relatedLesson == lesson.id }"
                >
                    <check-icon v-if="relatedLesson == lesson.id" /> <plus-icon v-else />
                </button>
            </span>

            <img class="recordArrow" src="@/assets/arrow-right-green.svg" alt="" />
        </router-link>
    </li>
</template>

<script>
import LessonStar from "@/components/Player/Lessons/lesson-star";
import { PlusIcon, CheckIcon } from "vue-feather-icons";
export default {
    name: "skill-lesson-record",
    components: { LessonStar, PlusIcon, CheckIcon },
    props: {
        lesson: {
            type: Object,
            required: true,
        },
        relatedLesson: {
            required: false,
        },
    },
    methods: {
        AddLesson() {
            if (this.lesson.id == this.relatedLesson) {
                this.$emit("AddRelatedLesson", "");
            } else {
                this.$emit("AddRelatedLesson", this.lesson.id);
            }
        },
    },
};
</script>

<style lang="scss">
.historyLesson {
    background: #eef5f2;
    border-radius: $radius;
    margin-bottom: 10px;
    padding: 17px 20px;
    position: relative;
    list-style-type: none;

    a {
        font-weight: 200;
        text-decoration: none;
        color: $green_0;
    }

    .button {
        position: absolute;
        top: 0px;
        width: 64px;
        height: 100% !important;
        right: 0px;
        border-radius: 0px;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        width: 64px;
        padding: 0px;
        background: #15f29f;
        &:before {
            content: "";
            width: 12px;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: #edf5f2;
            border-top-right-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        &.active {
            background: #60c45c;
        }

        svg {
            width: 18px;
            margin-left: 10px;
            margin-top: 5px;
        }
    }

    &.noRecord {
        strong {
            font-weight: 400;
            display: block;
            margin-top: 10px;
        }
    }
    b {
        font-weight: 400;
        margin-bottom: 10px;
        display: block;
    }
    .recordArrow {
        position: absolute;
        right: 75px;
        bottom: 20px;
        pointer-events: none;
        z-index: 1;
    }
    .star {
        position: absolute;
        right: 95px;
        bottom: 14px;
        top: auto;
    }
}
</style>
